export const CHECK_FAILED = "Couldn't check that name - please try again"
export const TAKEN = 'That company name is already taken - try a different one'
export const UNUSABLE = "That company name can't be used"

// The journey's own copy talks about the web address the name becomes, because
// there it is claiming one. The drawer renames without touching the handle, so
// the same rules are worded as what they are here: a name customers will read.
const MESSAGES = {
  blank: '',
  unusable: 'Use letters or numbers customers can type',
  too_short: 'That name is too short - use at least 3 letters or numbers',
  too_long: 'That name is too long - use at most 32 letters or numbers',
  no_letters: 'Add at least one letter to your company name',
  invalid_chars: 'Use only letters and numbers in your company name'
}

export function companyNameError({ result, netError = false } = {}) {
  if (netError) return CHECK_FAILED
  if (!result) return ''
  if (result.valid && result.available) return ''
  if (result.valid) return TAKEN
  return MESSAGES[result.reason] === undefined ? UNUSABLE : MESSAGES[result.reason]
}

export function companyNameAccepted(result) {
  return Boolean(result && result.valid && result.available)
}
